import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { SelectMenu } from 'components/chec'

const HEADER_FOOTER_OFFSET = 280

export const AdvancedSearchWrap = styled.div`
  overflow-y: auto;
  max-height: calc(100vh - ${HEADER_FOOTER_OFFSET}px);
`

export const ClearFilters = styled.span`
  font-size: 12px;
  &:hover {
    color: ${themeColor('clearFiltersBtnIconColor')};
  }
  padding-right: 5px;
  cursor: pointer;
`

export const StyledSelectMenu = styled(SelectMenu)`
  margin-bottom: 8px;
`

export const AdvancedSearchOuterWrap = styled.div`
  margin-top: 16px;
`

export const AdvancedSearchFiltersHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const AdvancedFiltersTitle = styled.span`
  color: var(--Black-Black-Secondary, rgba(7, 7, 15, 0.7));
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Arial;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`
